<ppl-accordion [title]="'Timesheet Summary'" [isOpen]="true">
  @if(!isReadOnly) {
  <div>
    <div class="custom-row">
      @if(entry !== 'participantEnrollment'){
      <div class="me-2">
        <ppl-button label="Add Time Entries" icon="fa fa-plus" [customClass]="'primary-button'" [iconPosition]="'left'"
          (click)="addTimeentries()" *authorize="[pageId, tabId, 'AddTimeenties', 'section', 'edit']"></ppl-button>
      </div>
      }
    </div>
  </div>
  }

  <ppl-accordion [title]="'In Process Payroll'" [isOpen]="true">
    @if(inProgressPayroll?.length > 0){
    <ppl-list-table rowDataAccessibilityKey="tas_timesheetheader_detail_id" [disableSort]="false" [disableSearch]="true"
      [showCustomSearch]="false" [enableActions]="true" [disableSelection]="true" [pageConfig]="programName"
      [sharedDataKey]="sharedDataKey" [actionButtons]="actionButtons"
      [columnsToBeHidden]="columnsToBeHidden" [actionsToBeHidden]="actionsToBeHidden"
      (gridAction)="onAction($event, false)" [data]="inProgressPayroll" [pagination]="true" [from]="'claims'"
      [jsonList]="'list_provider_timesheet_in_process'">
    </ppl-list-table>
    }@else {
    <nz-row>
      <p>No Data found</p>
    </nz-row>
    }
  </ppl-accordion>

  <ppl-timesheet-provider-processed-list></ppl-timesheet-provider-processed-list>

  <ppl-timesheet-provider-denied-list></ppl-timesheet-provider-denied-list>

</ppl-accordion>


<div class="filter-panel">
  <ng-template #timesheetDialog let-cancel="cancel">
    <ppl-timesheets-add-entries [entryType]="timeEntry" [payPeriod]="filetredPayPeriod" [consumers]="consumers"
      [action]="action" [timesheetData]="timesheetData" [entryPage]="timeEntry" [isReadOnly]="isReadOnly"
      (timesheetAdded)="timesheetAdded($event)"></ppl-timesheets-add-entries>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #timesheetViewDialog let-cancel="cancel">
    <ppl-timesheet-view [isProcessed]="isProcessed" [consumers]="consumers" [providerId]="providerId"
      [payrollScheduleId]="payrollScheduleId" [isReadOnly]="isReadOnly"></ppl-timesheet-view>
  </ng-template>
</div>